export default __webpack_public_path__ + "static/media/7k.fc99ffa2.gif";